import { useContext } from 'react';
import { PricingContextType, PricingContext } from '@/contexts/pricingContext';

const usePricingContext = (): PricingContextType => useContext(PricingContext);

export default usePricingContext;
